export default {
    sent: 'Invitation sent',
    confirmed: 'Verifier confirmed',
    canceled: 'Canceled'
}